/**
 * 「人気No.1」ラベルを付けるプラン名。
 * API の `isRecommended`(おすすめ)とは別の概念なので、名前で固定する。
 */
export const mostPopularPlanName = 'スタンダード'

// 定期購入停止アンケートの選択肢（Vue cancel/form と同一）
export const cancelReasons = [
  'ポイントを使い切れなかった',
  '利用時の体験がよくなかった',
  '行きたい施設がなかった',
  '時間が合わなかった',
  '間違えて契約してしまった',
  'ジムの月額会員になった',
  'その他',
] as const

export const cancelIntentsToContinue = [
  '一旦停止するが、また定期購入サービスの利用再開を検討したい',
  '保有しているポイントを消費し終えたら、利用終了したい',
  'もう利用しない',
  '分からない／決めていない',
] as const

export type CancelReason = (typeof cancelReasons)[number]
export type CancelIntentToContinue = (typeof cancelIntentsToContinue)[number]
